import rem from 'polished/lib/helpers/rem';
import theme from 'styled-theming';
import styled, { createGlobalStyle } from 'styled-components';
import styledNormalize from 'styled-normalize';

import Roboto from '../fonts/Roboto-Regular.ttf';
import RobotoMedium from '../fonts/Roboto-Regular.ttf';
import RobotoBold from '../fonts/Roboto-Regular.ttf';
import { em } from 'polished';

const _rem = size => rem(size, '16px');
const _em = size => em(size, '16px');

export const textColor = theme('mode', {
  mobile: '#000',
  desktop: 'red',
});

export const colors = {
  primary: '#F35C58',
  primaryHover: '#DB524F',
  gradientStart: '#F47256',
  gradientEnd: '#F35959',
  black: '#000',
  white: '#FFF',
  grey: '#E2E5E9',
  greyHover: '#EDF1F7',
  mediumGrey: '#F1F4F8',
  darkGrey: '#606163',
  pink: '#B4004E',
  lightPurple: '#BF3BBF',
  green: '#2E7D32',
  purple: '#4D2C91',
  background: '#F6F9FD',
  titleBackground: '#F1F2FA',
  red: '#D0021B',
};

export const device = {
  mobile: `(max-width: 425px)`,
  tablet: `(min-width: 426px)`,
  desktop: `(min-width: 1025px)`,
};

export const defaultFontFamily = 'Roboto, Helvetica, Arial, Verdana, Tahoma, sans-serif';

export const ContentWrapper = styled.div`
  position: relative;
  padding: ${props => (props.paddingY ? rem(props.paddingY) : 0)}
    ${props => (props.paddingX ? rem(props.paddingX) : 0)};
`;

export const DefaultWrapper = styled.div`
  @media ${device.desktop} {
    max-width: ${rem(1070)};
    margin: auto;
    padding-top: ${rem(38)};
  }

  @media ${device.mobile} {
    padding: ${rem(16)};
  }
`;

export const GlobalStyles = createGlobalStyle`
  ${styledNormalize}

  *{
    margin: 0;
    font-family: ${defaultFontFamily};
  }

  body{
    background: ${colors.mediumGrey};
  }

  button{cursor: pointer;}

  @font-face {
    font-family: 'Roboto';
    src: url(${Roboto}) format('truetype');
    font-weight: regular;
    font-style: normal;
  }

  @font-face {
    font-family: 'RobotoMedium';
    src: url(${RobotoMedium}) format('truetype');
    font-weight: medium;
    font-style: normal;
  }

  @font-face {
    font-family: 'RobotoBold';
    src: url(${RobotoBold}) format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  hr{ 
    border: 0; 
    border-top: 1px solid ${colors.grey};
  }
`;

export const swiperMobileParams = {
  slidesPerView: 4,
  spaceBetween: 10,
  loop: true,
  containerClass: 'swiper-mobile',
};

export const swiperParams = {
  slidesPerView: 6,
  spaceBetween: 10,
  loop: true,
  containerClass: 'swiper-desktop',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

export { _rem as rem, _em as em };
